import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventVisibilityModeModel } from 'src/app/models/event-visibility-mode.model';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { RoleModel } from 'src/app/models/person/role.model';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';
import { TenantSubscriberModel } from 'src/app/models/subscription/tenant-subscriber.model';
import { TrainingCategoryModel } from 'src/app/models/training-category/training-category.model';
import { TrainingGroupModel } from 'src/app/models/training-group.model';

@Component({
  selector: 'app-publish-to-subscribers-section',
  standalone: false,
  templateUrl: './publish-to-subscribers-section.component.html',
  styleUrl: './publish-to-subscribers-section.component.scss',
})
export class PublishToSubscribersSectionComponent {
  @Input() isViewMode = false;
  @Input() visibilityMode: EventVisibilityModeModel = 
    EventVisibilityModeModel.Subscribers;

  @Input() personCount = 0;
    
  @Input() selectedOrganizationUnitIds: string[] = [];

  @Input() organizationUnits: OrganisationUnitModel[] = [];
  @Input() trainingGroups: TrainingGroupModel[] = [];
  @Input() standardTrainingCategories: StandardTrainingCategoryViewModel[] = [];
  @Input() trainingCategories: TrainingCategoryModel[] = [];
  @Input() subscribers: TenantSubscriberModel[] = [];
  @Input() roles: RoleModel[] = [];
  @Input() usedStandardTrainingCategories: StandardTrainingCategoryViewModel[] = [];

  @Input() trainingGroupIds: string[] = [];
  @Input() standardTrainingCategoryIds: string[] = [];
  @Input() trainingCategoryIds: string[] = [];
  @Input() subscriptionIds: string[] = [];
  @Input() roleIds: string[] = [];

  @Output() visibilityModeChange = new EventEmitter<EventVisibilityModeModel | null>();
  @Output() selectedOrganizationUnitIdsChange = new EventEmitter<string[]>();
  @Output() trainingGroupIdsChange = new EventEmitter<string[]>();
  @Output() standardTrainingCategoryIdsChange = new EventEmitter<string[]>();
  @Output() trainingCategoryIdsChange = new EventEmitter<string[]>();
  @Output() subscriptionIdsChange = new EventEmitter<string[]>();
  @Output() roleIdsChange = new EventEmitter<string[]>();
    
  EventVisibilityMode = EventVisibilityModeModel;

  onVisibilityModeChanged(mode: EventVisibilityModeModel): void {
    this.visibilityMode = mode;
    this.visibilityModeChange.emit(mode);
  }

  onOrganizationUnitIdsChanged(ids: string[]): void {
    this.selectedOrganizationUnitIds = ids;
    this.selectedOrganizationUnitIdsChange.emit(ids);
  }

  onTrainingGroupIdsChanged(ids: string[]): void {
    this.trainingGroupIds = ids;
    this.trainingGroupIdsChange.emit(ids);
  }

  onSubscriptionIdsChanged(ids: string[]): void {
    this.subscriptionIds = ids;
    this.subscriptionIdsChange.emit(ids);
  }

  onRoleIdsChanged(ids: string[]): void {
    this.roleIds = ids;
    this.roleIdsChange.emit(ids);
  }

  onStandardTrainingCategoryIdsChanged(ids: string[]): void {
    this.standardTrainingCategoryIds = ids;
    this.standardTrainingCategoryIdsChange.emit(ids);
  }

  onTrainingCategoryIdsChanged(ids: string[]): void {
    this.trainingCategoryIds = ids;
    this.trainingCategoryIdsChange.emit(ids);
  }
}
